import { render } from "./LandingPage.vue?vue&type=template&id=24a8bd20&scoped=true"
import script from "./LandingPage.vue?vue&type=script&lang=js"
export * from "./LandingPage.vue?vue&type=script&lang=js"

import "./LandingPage.vue?vue&type=style&index=0&id=24a8bd20&lang=css"
import "./LandingPage.vue?vue&type=style&index=1&id=24a8bd20&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24a8bd20"]])

export default __exports__